import { A, useNavigate } from '@solidjs/router'
import { userStore } from '/web/store'
import { isLoggedIn } from '/web/store/api'
import HeaderAccountMenu from './Header/HeaderAccountMenu'
import { Show } from 'solid-js'
import { subscribe } from '/web/store/socket'

const Header = (props: { showMenu?: boolean }) => {
  const nav = useNavigate()
  const user = userStore()

  subscribe('profile-tokens-changed', { userId: 'string', tokens: 'number' }, (body) => {
    if (user.profile) {
      userStore.setState({ profile: { ...user.profile, totalAvailableTokens: body.tokens } })
    }
  })

  return (
    <div class="flex h-[58px] items-center justify-between font-clash md:h-[82px] ">
      <div class="flex flex-shrink-0 items-center gap-2">
        <Show when={props.showMenu ?? false}>
          <button
            class="mb-1 block flex-shrink-0 lg:hidden"
            onClick={() => userStore.openSideMenu()}
          >
            <img src="/images/burger.png" alt="" class="h-[35px] w-[35px]" />
          </button>
        </Show>
        <A href="/">
          <img
            class="mt-1  h-[26.43px] w-[120px]  md:h-[38px] md:w-[175px]"
            src={'/images/cosplayfans-logo.png'}
            alt="logo"
          />
        </A>
      </div>
      <div class="flex items-center justify-center gap-6 lg:gap-4">
        <button
          onClick={() => {
            if (!isLoggedIn()) {
              userStore.loginModal(true)
            } else {
              return nav('/generate-image/')
            }
          }}
          class="bg-opacity-7 text-shadow hidden h-7 flex-shrink-0 items-center justify-center rounded-md border border-white bg-[#0000001e] px-3 font-clash text-xs font-medium text-white shadow backdrop-blur lg:flex"
        >
          GENERATE IMAGE
        </button>
        <button
          onClick={() => {
            if (!isLoggedIn()) {
              userStore.loginModal(true)
            } else {
              return nav('/chat/')
            }
          }}
          class="bg-opacity-7 text-shadow hidden h-7 flex-shrink-0 items-center justify-center rounded-md border border-white bg-[#0000001e] px-4 font-clash text-xs font-medium text-white shadow backdrop-blur lg:flex"
        >
          LIVE CHAT
        </button>
        <button
          onClick={() => userStore.directoryModal(true)}
          class="bg-opacity-7 text-shadow hidden h-7 flex-shrink-0 items-center justify-center rounded-md border border-white bg-[#0000001e] px-3 font-clash text-xs font-medium text-white shadow backdrop-blur lg:flex"
        >
          DIRECTORY
        </button>
        <Show when={!isLoggedIn()}>
          <button
            onClick={() => {
              userStore.loginModal(true)
            }}
            class="bg-opacity-7 bg-blur text-shadow flex h-[28px] flex-shrink-0 items-center gap-2 rounded-md border bg-red-500 px-2 font-clash text-xs font-medium text-white shadow lg:h-7"
          >
            <img src="/images/tokens-star.png" class="h-5 w-5" />
            <span>BUY TOKENS</span>
          </button>
          <button
            onClick={() => userStore.loginModal(true)}
            class="text-shadow hidden h-[30px] w-[90px] flex-shrink-0 rounded-md border border-white bg-gradient-to-r from-purple-600 to-blue-600 font-clash text-xs font-medium text-white shadow lg:block"
          >
            SIGN IN
          </button>
        </Show>
        <Show when={isLoggedIn()}>
          <button
            onClick={() => {
              userStore.buyTokensModal(true)
            }}
            class="bg-opacity-7 bg-blur text-shadow flex h-[28px] flex-shrink-0 items-center gap-2 rounded-md border bg-red-500 px-2 font-clash text-xs font-medium text-white shadow lg:h-7"
          >
            <img src="/images/tokens-star.png" class="h-5 w-5" />
            {user?.profile?.totalAvailableTokens || 0} TOKENS
          </button>
          <div class="hidden h-[30px] md:block">
            <HeaderAccountMenu username={user?.profile?.handle} />
          </div>
        </Show>
      </div>
    </div>
  )
}

export default Header
